import {
  ACHIEVEMENTS_SUPPORTED,
  unlockAchievement,
} from "../utils/Achievements";
import { Achievement } from "./Achievement";
import { PlayerContextState } from "./PlayerContext";
import { addContextListener } from "./PlayerContextListeners";
import { Storyline } from "./storylines/Storylines";

const achievementsUnlocked: Partial<Record<Achievement, boolean>> = {};

export function registerAchievementUnlocker(
  checker: (state: PlayerContextState) => boolean,
  achievement: Achievement,
) {
  // Do not add achievements if not supported, to avoid all the calculations
  if (ACHIEVEMENTS_SUPPORTED) {
    addContextListener(achievement + "unlocker", (state) => {
      // Using local stored values for throttling rather than flags,
      // so that restarting the game will re-unlock achievements, just in case
      if (!achievementsUnlocked?.[achievement] && checker(state)) {
        unlockAchievement(achievement);
        achievementsUnlocked[achievement] = true;
      }
    });
  }
}

export function registerAchievementUnlockerFromStoryline(
  storyline: Storyline,
  achievement: Achievement,
) {
  registerAchievementUnlocker(
    (state) => storyline.isCompleted(state),
    achievement,
  );
}
